import "../../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import { selectIsFilterValuesSelected } from "../../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectVehiclesCount } from "./selectVehiclesCount.js";
const selectIsVehiclesDataMissing = createAppSelector(
  [selectVehiclesCount, selectIsFilterValuesSelected],
  (vehiclesCount, isFilterValuesSelected) => {
    return vehiclesCount === 0 && !isFilterValuesSelected;
  }
);
export {
  selectIsVehiclesDataMissing
};
